import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import _get from 'lodash/get';
import { slugify } from '@surfline/web-common';
import { subregionForecastPath } from '@surfline/web-common/dist/paths/kbyg';
import config from '../../config';

const getClassName = map =>
  classNames({
    'sl-subregion-header': true,
    'sl-subregion-header--map': map,
  });

const SubregionHeaderLink = ({ children, subregion, map }) => {
  const { name, id } = subregion;
  const status = _get(subregion, 'forecastStatus.status', 'off');
  return (
    <div>
      {status === 'off' ? (
        <a
          className={getClassName(map)}
          href={`${config.productAPI}/kbyg/redirect/legacy/subregion/${id}`}
        >
          {children}
        </a>
      ) : (
        <Link className={getClassName(map)} to={subregionForecastPath(slugify(name), id)}>
          {children}
        </Link>
      )}
    </div>
  );
};

SubregionHeaderLink.propTypes = {
  children: PropTypes.node,
  subregion: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    forecastStatus: PropTypes.shape({
      status: PropTypes.string,
      inactiveMessage: PropTypes.string,
    }),
  }).isRequired,
  map: PropTypes.bool,
};

SubregionHeaderLink.defaultProps = {
  children: null,
  map: false,
};

export default SubregionHeaderLink;
